import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { getColor } from 'helpers/utils';
import { setConfig } from 'reducers/configReducer';

import useToggleStyle from './hooks/useToggleStyle';

const Main = props => {
  const { isRTL, isDark, theme } = useSelector(state => state.config);

  const dispatch = useDispatch();

  const { isLoaded } = useToggleStyle(isRTL, isDark);

  useEffect(() => {
    const isDark =
      theme === 'auto'
        ? window.matchMedia('(prefers-color-scheme: dark)').matches
        : theme === 'dark';

    dispatch(setConfig({ key: 'isDark', value: isDark }));
  }, [theme]);

  if (!isLoaded) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: isDark ? getColor('dark') : getColor('light')
        }}
      />
    );
  }

  return <>{props.children}</>;
};

Main.propTypes = { children: PropTypes.node };

export default Main;
